import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

// All routes are lazy-loaded so the initial bundle only contains the shell.
// Each route gets its own uniquely-named chunk for optimal caching.
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
  },
  {
    path: "/contacts",
    name: "contacts",
    component: () =>
      import(/* webpackChunkName: "contacts" */ "../views/ContactsView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () =>
      import(/* webpackChunkName: "product" */ "../views/ProductView.vue"),
  },
  {
    path: "/buy",
    name: "buy",
    component: () =>
      import(/* webpackChunkName: "buy" */ "../views/BuyView.vue"),
  },
  {
    path: "/gallery",
    name: "gallery",
    component: () =>
      import(/* webpackChunkName: "gallery" */ "../views/GalleryView.vue"),
  },
  {
    path: "/menu/groupexercises",
    name: "GroupExercises",
    component: () =>
      import(
        /* webpackChunkName: "menu-group" */ "../views/menu/GroupExercises.vue"
      ),
  },
  {
    path: "/menu/BarMenuNew",
    name: "BarMenuNew",
    component: () =>
      import(
        /* webpackChunkName: "menu-bar-new" */ "../views/menu/BarMenuNew.vue"
      ),
  },
  {
    path: "/menu/barmenu",
    name: "BarMenu",
    component: () =>
      import(/* webpackChunkName: "menu-bar" */ "../views/menu/BarMenu.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
export default router;
